import { getPlatformFee } from '@peach/types/payments/fees.js';
import { formatPrice } from '@peach/types/utils/currencies.js';

/** What a client pays for a price: the price plus the Platform fee. */
export function withFees(amount: number): number {
  return Number((amount + getPlatformFee(amount)).toFixed(2));
}

/**
 * The two numbers a price is: what lands in the owner's wallet, first and
 * whole, then what leaves the client's card. Fees ride on top of the price
 * rather than out of it, and the card beside the owner quotes the second.
 */
export function priceSplitNote(price: number, currency: string): string {
  return `You get the full ${formatPrice({ amount: price, currency })}. Your client pays ${formatPrice({ amount: withFees(price), currency })}, fees included.`;
}

/**
 * The deal switch's line, in the figure a client sees struck (fees included, as
 * the card draws it): an offer while off, a fact while on.
 */
export function dealNote(on: boolean, struck: number, currency: string): string {
  const shown = formatPrice({ amount: withFees(struck), currency });
  return on ? `Clients see ${shown} crossed out` : `Show ${shown} crossed out`;
}
